import { render, staticRenderFns } from "./GalleriesDetailPage.vue?vue&type=template&id=032c35c2&scoped=true"
import script from "./GalleriesDetailPage.vue?vue&type=script&lang=js"
export * from "./GalleriesDetailPage.vue?vue&type=script&lang=js"
import style0 from "./GalleriesDetailPage.vue?vue&type=style&index=0&id=032c35c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c35c2",
  null
  
)

export default component.exports